import { logAppError } from './logAppError';

export interface ApiClientOptions extends RequestInit {
  path?: string;
  context?: string;
}

export const apiClient = async (url: string, options: ApiClientOptions = {}): Promise<Response> => {
  const { path, context, ...fetchOptions } = options;
  const endpointPath = path || url;
  
  try {
    const response = await fetch(url, fetchOptions);
    if (!response.ok) {
      // Try to parse error message if JSON, else use statusText
      let message = response.statusText;
      try {
        const cloned = response.clone();
        const data = await cloned.json();
        if (data && data.error) message = data.error;
        else if (data && data.message) message = data.message;
      } catch (e) {
        // ignore JSON parse error
      }
      
      await logAppError({
        source: 'frontend',
        statusCode: response.status,
        path: endpointPath,
        method: fetchOptions.method || 'GET',
        message: message,
        context: context,
      });
      throw new Error(message || `Request failed with status ${response.status}`);
    }
    return response;
  } catch (error: any) {
    await logAppError({
      source: 'frontend',
      statusCode: 0,
      path: endpointPath,
      method: fetchOptions.method || 'GET',
      message: error.message || 'Network error',
      context: context,
    });
    throw error;
  }
};
